import React from 'react';
import Modal from '../../../../../../Components/Modal/Modal';
import InsuranceCompany, { InsuranceCompanyValues } from './InsuranceCompany';
import { TermItem } from '../../../../../../graphql/graphql';
import { InsuranceSettings } from '../../../../Interfaces/insuranceSettings';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (values: InsuranceCompanyValues) => void;
	insuranceCompany: TermItem;
	settings: InsuranceSettings | null;
}

const InsuranceCompanyModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSubmit,
	insuranceCompany,
	settings,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} fullScreen={false}>
			<Modal.Header title={insuranceCompany.name} />
			<Modal.Content>
				<InsuranceCompany onSubmit={onSubmit} settings={settings} />
			</Modal.Content>
		</Modal>
	);
};

export default InsuranceCompanyModal;
